import React, { useState, useEffect } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faGears } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import apiService from './../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import { FaBars } from 'react-icons/fa';
import { getPermisosPaginas, savePermisosPaginas } from '../Utils/indexedDBUtils';
import Dropdown from "react-bootstrap/Dropdown";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";

function UserDropdown({ userName, userCargo, rolNombre, CloseSession }) {
  return (
    <Dropdown align="end" className="user-dropdown">
      <Dropdown.Toggle
        id="dropdown-basic"
        style={{ backgroundColor: "#3c8dbc" }}
      >
        <Image
          src="/dist/img/vidarlogo.jpg"
          width={20}
          height={20}
          roundedCircle
          className="user-image"
          alt="User"
        />
        <span className="hidden-xs">{userName}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {/* Perfil */}
        <Dropdown.Item as="div">
          <div className="d-flex align-items-center">
            <Image
              src="/dist/img/vidarlogo.jpg"
              alt="User Avatar"
              roundedCircle
              width={50}
              height={50}
              className="me-3"
            />
            <div>
              <p className="mb-0 text-sm">Perfil</p>
              <p className="mb-0"><b>{userCargo}</b></p>
              <p className="mb-0"><b>{rolNombre}</b></p>
            </div>
          </div>
        </Dropdown.Item>

        {/* Actualizar contraseña */}
        <Dropdown.Item href="/cambiarpassword">
          <Button variant="link" className="p-0">
            Actualizar contraseña
          </Button>
        </Dropdown.Item>

        {/* Cerrar sesión */}
        <Dropdown.Item as="div">
          <Button
            variant="primary"
            size="sm"
            className="w-100"
            onClick={CloseSession}
          >
            Cerrar sesión
          </Button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default function AppHeader() {
  const navigate = useNavigate();
  const { nombre, cargo, logout, user, rol, token, rolNombre, fetchPermisosPaginas } = useAuth();
  const [permisosPaginas, setPermisosPaginas] = useState([]);
  const [modoHacerDx, setModoHacerDx] = useState(false);
  const [userName] = useState(nombre);
  const [userCargo] = useState(cargo);
  useEffect(() => {
    consultarPermisosPaginas();
    ConsultarProfesionalParaAtencion();
  }, []);
  async function consultarPermisosPaginas() {
      const cachedPermisos = await getPermisosPaginas();
      if (cachedPermisos) {
          setPermisosPaginas(cachedPermisos);
      } else {
          // If not in IndexedDB, fetch from the API
          const permisos = await fetchPermisosPaginas();
          if (permisos) {
              setPermisosPaginas(permisos);
              await savePermisosPaginas(permisos); // Save the result to IndexedDB
          }
      }
  }
  function CloseSession() {
    logout();
    navigate("/login");
  };

  async function RegistrarProfesionalParaAtencion(modoHacerDx){
      const url = '/diagnostico/registrarprofesionalatencion';
      const obj = { usrId: user, estado: !modoHacerDx };
      try {
         setModoHacerDx(!modoHacerDx);
         await apiService.post(url, obj, token);
         
          
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  }
  async function ConsultarProfesionalParaAtencion() {
      const url = `/diagnostico/consultarprofesionalatencion?usrId=${user}`;
      try {
          const response = await apiService.get(url, token)
          if (response.statusText === 'OK') {
                setModoHacerDx(response.data.existeProfesional === 1);
          }
            
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  }
  
  return (
    <nav className="main-header navbar navbar-expand navbar-light" style={{backgroundColor:'#3c8dbc'}}>
        <ul className="navbar-nav">
          <li className="nav-item">
            <button 
              className="nav-link menu-toggle-btn"
              onClick={() => {
                document.body.classList.toggle('sidebar-open')
              }}
              type="button">
              <FaBars style={{color: 'white'}}/>
            </button>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          {permisosPaginas
                .filter(pagina => pagina.ppa_nombrepag === "Diagnostico dx")
                .map(pagina => pagina.ppe_rolid)
                .includes(Number.parseInt(rol)) && <li className="nav-item">
            {!modoHacerDx && <button className="btn btn-info" style={{backgroundColor: 'blue'}} data-widget="fullscreen" type="button" onClick={() => {RegistrarProfesionalParaAtencion(modoHacerDx)}}>
              <i className="fas fa-expand-arrows-alt" style={{color: 'white'}}><strong>Modo DX: inactivo</strong></i>
            </button>}
            {modoHacerDx && <button className="btn btn-info" style={{backgroundColor: 'green'}} data-widget="fullscreen" type="button" onClick={() => {RegistrarProfesionalParaAtencion(modoHacerDx)}}>
              <i className="fas fa-expand-arrows-alt" style={{color: 'white'}}><strong>Modo DX: activo</strong></i>
            </button>}
          </li>}
          <li className="nav-item">
            <UserDropdown 
              userName={userName} 
              userCargo={userCargo} 
              rolNombre={rolNombre} 
              CloseSession={CloseSession} 
            />
          </li>
          <li className="nav-item">
            <button className="nav-link" data-widget="control-sidebar" data-controlsidebar-slide="true" onClick={() => navigate('/dashboard')} type="button">
            <FontAwesomeIcon icon={faGears} />
            </button>
          </li>
        </ul>
      </nav>
    )
  }


